import { render, staticRenderFns } from "./FeedbackDialog.vue?vue&type=template&id=30561efd&scoped=true&"
import script from "./FeedbackDialog.vue?vue&type=script&lang=js&"
export * from "./FeedbackDialog.vue?vue&type=script&lang=js&"
import style0 from "./FeedbackDialog.vue?vue&type=style&index=0&id=30561efd&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "30561efd",
  null
  
)

export default component.exports